import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import { MyDatePickerModule } from 'mydatepicker';


import {
        HeaderComponent,
        ImageSliderComponent,
        GameItemComponent,
        ProfileUpdateFormComponent,
        FooterComponent,
        GroupGameItemComponent,
        LoaderComponent,
        SideBarComponent,
        PopInTextComponent,
        PasswordUpdateFormComponent,
        TransactionUpdateFormComponent,
        GameHistoryFormComponent
} from './components'
        ;
import {
  ImagePreloadDirective
} from './directives'
import{
  SafePipe,
  FilterPipe
} from './pipes'

import {
  CustomHttpService,
  AuthenticationService,
  EventService,
  GameService,
  ProfileService,
  LocalStorageService,
  GameGroupService,
  AuthGuardService,
  MobileService,
  PokerService
} from './services';
import {TranslateModule} from '@ngx-translate/core';
import {CatchTouchEventDirective} from './components/header/catch-touch-event.directive';

@NgModule({
  declarations: [
    HeaderComponent,
    ImageSliderComponent,
    GameItemComponent,
    ProfileUpdateFormComponent,
    FooterComponent,
    GroupGameItemComponent,
    ImagePreloadDirective,
    CatchTouchEventDirective,
    LoaderComponent,
    SafePipe,
    FilterPipe,
    SideBarComponent,
    PopInTextComponent,
    PasswordUpdateFormComponent,
    TransactionUpdateFormComponent,
    GameHistoryFormComponent
  ],
  providers: [
    CustomHttpService,
    LocalStorageService,
    EventService,
    GameService,
    ProfileService,
    GameGroupService,
    AuthGuardService,
    MobileService,
    PokerService
  ],
  exports: [
    HeaderComponent,
    ImageSliderComponent,
    GameItemComponent,
    ProfileUpdateFormComponent,
    FooterComponent,
    GroupGameItemComponent,
    ImagePreloadDirective,
    CatchTouchEventDirective,
    LoaderComponent,
    SafePipe,
    FilterPipe,
    SideBarComponent,
    PopInTextComponent,
    PasswordUpdateFormComponent,
    TransactionUpdateFormComponent,
    GameHistoryFormComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    MyDatePickerModule,
    TranslateModule
  ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/shared.module.ts